export default __webpack_public_path__ + "static/media/walkthrough-step3-4K.e393f2d1.jpg";